import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';
import { AuditLogsListReq } from '@/types/auditLogs';


export const auditLogsKeys = {
  all: [ 'auditLogs' ] as const,
  list: ( params?: AuditLogsListReq ) => [ ...auditLogsKeys.all, 'list', params ] as const
};

export function useAuditLogsQuery(
  params: AuditLogsListReq
) {
  return useQuery( {
    queryKey: auditLogsKeys.list( params ),
    queryFn: async() => {
      const result = await APIGateway.auditLogs.auditLogsGet( params );

      return result;
    }
  } );
}
